import React from 'react';

import { DataChip, DataChipList, type DataChipProps } from '@pkg/components';

export interface StatsListProps {
    items: DataChipProps[];
}

const FALLBACK_ITEM: DataChipProps = {
    label: 'Calculating…',
};

export function StatsList({ items = [] }: StatsListProps) {
    const itemRenderer = (props: DataChipProps, index: number) => (
        <DataChip key={`AssetCard-StatsList-${index}`} {...props} />
    );
    const itemsMarkup = items.length ? items.map(itemRenderer) : [FALLBACK_ITEM].map(itemRenderer);

    return <DataChipList wrap>{itemsMarkup}</DataChipList>;
}
